module.exports = __webpack_public_path__ + "static/media/bar_widget.26f750fa.jpg";